import React from 'react';
import './About.css';
import profileImage from '../assets/sanjay-profile.jpg';

const About = () => {
  return (
    <section id="about" className="about section">
      <div className="container">
        <h2 className="section-title">About Me</h2>
        <p className="section-subtitle">
          I build practical AI and analytics systems that make complex information easier to use.
        </p>

        <div className="about-content">
          <div className="about-main">
            <div className="about-photo-wrap">
              <img src={profileImage} alt="Sanjay profile" className="about-photo" loading="lazy" />
            </div>

            <div className="about-terminal">
              <div className="terminal-header">
                <span className="terminal-dot red" />
                <span className="terminal-dot yellow" />
                <span className="terminal-dot green" />
                <span className="terminal-title">about_sanjay.py</span>
              </div>
              <div className="terminal-body">
                <p className="terminal-line">
                  <span className="terminal-prompt">$</span> I enjoy taking messy, unstructured inputs and turning them into reliable tools people can actually use.
                </p>
                <p className="terminal-line">
                  <span className="terminal-prompt">$</span> My work style sits at the intersection of data analytics, automation, and applied AI, from model experiments to deployment-ready workflows.
                </p>
                <p className="terminal-line">
                  <span className="terminal-prompt">$</span> My core stack includes
                  <span className="terminal-highlight"> Python</span>,
                  <span className="terminal-highlight"> SQL</span>,
                  <span className="terminal-highlight"> Power BI</span>,
                  <span className="terminal-highlight"> UiPath</span>, and modern ML frameworks for end-to-end problem solving.
                </p>
                <p className="terminal-line">
                  <span className="terminal-prompt">$</span> Recent builds include PDF entity extraction with UiPath + NER, an AI therapy chatbot served through Flask and Ngrok, and health-economics analysis using correlation and regression.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
